import { Link, useSearchParams } from 'react-router-dom'
import { useTranslation } from '@papan/i18n'
import { AuthLayout } from '../components/AuthLayout'
import { ForgotPasswordForm } from '../components/ForgotPasswordForm'
import { safeNext } from '../lib/safe-next'

export function ForgotPasswordPage() {
  const { t } = useTranslation('auth')
  const [searchParams] = useSearchParams()
  const rawNext = searchParams.get('next')
  const loginTarget = rawNext
    ? `/login?next=${encodeURIComponent(safeNext(rawNext))}`
    : '/login'
  return (
    <AuthLayout
      footer={
        <Link to={loginTarget} className="text-blue-400 hover:text-blue-300">
          {t('forgotPassword.backToLogin')}
        </Link>
      }
    >
      <ForgotPasswordForm />
    </AuthLayout>
  )
}
